/**
 * The following scripts get applied on the frontend of your site.
 */

jQuery(document).ready(function ($) {

    $('.wp-block-fbo-map').each(function () {

        // define vars
        const data_attributes = JSON.parse($(this).attr('data-map'));
        const text = data_attributes['text'];
        const address = data_attributes['address'];
        const position = data_attributes['position'];
        const zoom = data_attributes['zoom'];
        const zoomControl = data_attributes['zoomControl'];
        const markerIcon = data_attributes['marker'].replace('{pluginUrl}', Blocks.pluginUrl).replace('{theme}', Blocks.themeUrl);


        // init map
        const map = L.map($(this).attr('id'), {
            zoomControl: zoomControl
        }).setView(position, zoom);

        // add tile layer
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }).addTo(map);

        // marker icon
        var customIcon = L.icon({
            iconUrl: markerIcon || `${Blocks.pluginUrl}assets/src/img/marker.svg`,
            iconSize: [40, 40],
            iconAnchor: [40, 40],
            popupAnchor: [-20, -40],
        });

        // add marker
        var marker = L.marker(position, { icon: customIcon }).addTo(map);

        // add popup
        if (text) {
            marker.bindPopup(text).openPopup();
        }

    })


})